import script from "./UIHint.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIHint.vue?vue&type=script&setup=true&lang=ts"

import "./UIHint.vue?vue&type=style&index=0&id=332574a1&lang=css"

const __exports__ = script;

export default __exports__